import { Box, Divider } from "@mui/material";
import React from "react";
import { ShowHistoric } from "@features/depots/components/DepotsDashboard/ShowHistoric";
import { ExportButton } from "@features/depots/components/DepotsDashboard/ExportButton";
import { useMandatorVisibility } from "@helpers";
import { CurrencyToggle } from "@components";
import { useInvestmentActionsLayout } from "./useInvestmentActionsLayout";

type Props = {
  onShowHistoricChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  activeTab?: string;
  accountIds: number[];
  minDate: string;
  maxDate: string;
  showHistoric: boolean;
  currency?: string;
};

export const InvestmentActionsBar = ({
  activeTab,
  showHistoric,
  minDate,
  maxDate,
  onShowHistoricChange,
  accountIds,
  currency,
}: Props) => {
  const { isNarrow, isVeryNarrow, canShowCurrencyToggle } =
    useInvestmentActionsLayout();
  const isVisible = useMandatorVisibility({ hideFor: ["kpmg-germany"] });

  const isInvestmentsTab = activeTab === "investments";
  const showToggle = canShowCurrencyToggle && !isNarrow;
  const showCheckbox = isInvestmentsTab && !isNarrow && isVisible;
  const showExport = !isVeryNarrow;

  if (!showToggle && !showCheckbox && !showExport) return null;

  const items: React.ReactNode[] = [
    showToggle && (
      <CurrencyToggle
        key="toggle"
        storageKey="currency-toggle-investments-list"
      />
    ),
    showCheckbox && (
      <ShowHistoric
        key="historic"
        checked={showHistoric}
        onChange={onShowHistoricChange}
      />
    ),
    showExport && (
      <ExportButton
        key="export"
        activeTab={activeTab}
        currency={currency}
        params={{
          accountId: accountIds,
          includeHistoric: showHistoric,
          minDate,
          maxDate,
        }}
      />
    ),
  ].filter(Boolean);

  return (
    <Box display="flex" alignItems="center" gap={5}>
      {items.map((item, index) => (
        <React.Fragment key={(item as React.ReactElement).key ?? index}>
          {index > 0 && (
            <Divider
              orientation="vertical"
              flexItem
              sx={{
                height: "28px",
              }}
            />
          )}
          {item}
        </React.Fragment>
      ))}
    </Box>
  );
};
